// Fulfillment-bucket capability toggle (Slice 3).
//
// Source: docs/planning/sales_fulfillment_bucket.md §3.
//
// Flips the per-org `organizations.has_sales_floor` capability bit
// that gates the Fulfillment bucket's nav visibility + intake-form
// API access. Default is `true` for every org (retail-flavored);
// admins flip it off only for plant-only manufacturer orgs that
// don't run a sales floor. Saved via the dedicated
// `admin_set_has_sales_floor` RPC (security-definer, is_org_admin
// gate) — independent from the branding save flow so a stray
// branding-save can't accidentally toggle the capability.

import type { Dispatch, SetStateAction } from "react";

export function OrgSettingsSectionFulfillment(props: {
  hasSalesFloor: boolean;
  setHasSalesFloor: Dispatch<SetStateAction<boolean>>;
  saving: boolean;
  onSave: () => void | Promise<void>;
}) {
  const { hasSalesFloor, setHasSalesFloor, saving, onSave } = props;
  return (
    <div className="pt-2 border-t border-gray-100">
      <div className="mb-3 rounded-lg border border-emerald-200 bg-emerald-50 p-3">
        <p className="text-xs font-semibold text-emerald-900">Fulfillment bucket (capability)</p>
        <p className="mt-1 text-[11px] text-emerald-900/80">
          When enabled, this organization's users see the Fulfillment bucket (Inventory / Intake forms /
          New inventory) in their nav, the daily-checklist intake-pending nag fires for sales-role users,
          and the fulfillment API endpoints accept calls. Disable for plant-only manufacturer orgs that
          don't run a retail sales floor. Default: enabled.
        </p>
        <label className="mt-2 inline-flex items-center gap-2 text-xs text-emerald-900">
          <input
            type="checkbox"
            checked={hasSalesFloor}
            onChange={(e) => setHasSalesFloor(e.target.checked)}
            disabled={saving}
          />
          Sales floor enabled (Fulfillment bucket visible)
        </label>
        <div className="mt-2">
          <button
            type="button"
            onClick={() => void onSave()}
            disabled={saving}
            className="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs hover:bg-emerald-700 disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save sales-floor capability"}
          </button>
        </div>
      </div>
    </div>
  );
}
